export default __webpack_public_path__ + "static/media/2.ee11c038.jpg";